module.exports = __webpack_public_path__ + "img/partner-banner.23408641.png";